import React, { Component } from 'react'
import WarningIcon from '@components/Icon/Warning'

class AccessDenied extends Component {
  render () {
    return (
      <div className='access-denied-wrapper'>
        <WarningIcon />
        <div>You don't have required permissions to access this page.</div>
      </div>
    )
  }
}

export default AccessDenied
